/**
 * Premium season-pass status as last confirmed by the server (D112). Cached for
 * offline play only — online matches ask the server, so editing this cache
 * changes nothing there.
 */
const KEY = 'atf-entitlements';

export function cachedPremium(): boolean {
  try {
    return JSON.parse(localStorage.getItem(KEY) ?? '{}')?.premium === true;
  } catch {
    return false;
  }
}

export function cachePremium(premium: boolean): void {
  try {
    localStorage.setItem(KEY, JSON.stringify({ premium, at: Date.now() }));
  } catch {
    /* storage blocked */
  }
}
